<grid-toast *ngIf="result !== undefined" [type]="type" [dismissable]="false">
  <div slot="text">{{ message }}</div>
</grid-toast>
